import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Link, TextField } from '@mui/material';
import { Alert, Button, Stack } from '../design-system';
import { useAuth } from '../context/AuthContext';
import { AuthLayout } from './LoginPageModern';

export default function ForgotPasswordPage() {
  const { resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await resetPassword(email.trim());
      setMessage('Si existe una cuenta con este email, recibirás instrucciones para restablecer la contraseña.');
    } catch (resetError) {
      setError(resetError.message || 'No se pudo solicitar el cambio de contraseña.');
    } finally {
      setSubmitting(false);
    }
  };
  return <AuthLayout title="Restablecer contraseña" subtitle="Te enviaremos un enlace seguro por email">
    <Stack component="form" onSubmit={submit} spacing={2}>
      {message && <Alert severity="success">{message}</Alert>}
      {error && <Alert severity="error">{error}</Alert>}
      <TextField label="Email" type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" required fullWidth />
      <Button type="submit" variant="contained" disabled={submitting}>{submitting ? 'Enviando...' : 'Enviar enlace'}</Button>
      <Link component={RouterLink} to="/login" align="center">Volver a iniciar sesión</Link>
    </Stack>
  </AuthLayout>;
}
